import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {GameInfo, BrandInfo} from "app/types/game";

export interface LatestBetOrder {
    userid: number;
    gameid: number;
    gameId: string | number;
    type: number;
    in: number;
    out: number;
    multiple: number;
    time: number;
    rid: number;
    orderid: string;
    username: string;
    gamename: string;
}

export interface GameState {
    latestBetOrder?: LatestBetOrder;
    highRollers?: LatestBetOrder;
    winAmount: number;
    gameList: GameInfo[];
    brandList: BrandInfo[];
    isUserPlayRealGame: boolean;
}

const initialState: GameState = {
    winAmount: 0,
    gameList: [],
    brandList: [],
    isUserPlayRealGame: false,
};

export const gameSlice = createSlice({
    name: "game",
    initialState,
    reducers: {
        enableUserPlayRealGame: (state) => {
            state.isUserPlayRealGame = true;
        },
        disableUserPlayRealGame: (state) => {
            state.isUserPlayRealGame = false;
        },
        updateLatestBets: (state, action: PayloadAction<LatestBetOrder>) => {
            state.latestBetOrder = action.payload;
        },
        updateHighRollers: (state, action: PayloadAction<LatestBetOrder>) => {
            state.highRollers = action.payload;
        },
        setWinAmount: (state, action: PayloadAction<number>) => {
            state.winAmount = action.payload;
        },
        setGameList: (state, action: PayloadAction<GameInfo[]>) => {
            state.gameList = action.payload;
        },
        setBrandList: (state, action: PayloadAction<BrandInfo[]>) => {
            state.brandList = action.payload;
        },
    },
});

export const {enableUserPlayRealGame, disableUserPlayRealGame, updateLatestBets, updateHighRollers, setWinAmount, setGameList, setBrandList} = gameSlice.actions;

export default gameSlice.reducer;
